module.exports = __webpack_public_path__ + "628b60e370dfb210cc20a14cd7852dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/tiyan/tiyan2.jpg
// module id = 1231
// module chunks = 0